import { render, staticRenderFns } from "./ButtonAdd.vue?vue&type=template&id=31a082e2&scoped=true"
import script from "./ButtonAdd.vue?vue&type=script&lang=js"
export * from "./ButtonAdd.vue?vue&type=script&lang=js"
import style0 from "./ButtonAdd.vue?vue&type=style&index=0&id=31a082e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a082e2",
  null
  
)

export default component.exports